function getUpdaterElement() {
    let elem = document.querySelector('#updating');
    if (!elem) {
        require('./auto-updater-ui.less');
        const div = document.createElement('div');
        div.innerHTML = require('!raw-loader!extract-loader!html-loader!./auto-update-ui.html');
        elem = div.firstChild;
        document.body.appendChild(elem);
    }
    return elem;
}

export function show() {
    let elem = getUpdaterElement();
    elem.style.display = 'block';
}

export function hide() {
    let elem = getUpdaterElement();
    elem.style.display = 'none';
}

export function setProgress(progress) {
    let elem = getUpdaterElement();
    let progressElem = elem.querySelector('.update-progress');
    if (progressElem) {
        progressElem.style.width = `${progress * 100}%`;
    }
}



// WEBPACK FOOTER //
// ./src/shared/childupp-auto-update/cordova-auto-update/ui/index.js